const dashboard = {
	title: "Dashboard",
	no_upcoming_course: "No upcoming course",
	duration: "Duration",
	enrolled: "Enrolled",
	students: "Students",
};
export default dashboard;